var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "dialog-container",
          attrs: {
            width: "500px",
            title: "图片裁剪",
            visible: _vm.visible,
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
            },
            [
              _c("div", { staticClass: "body" }, [
                _c("div", { staticClass: "cropp-content container" }, [
                  _c("div", { staticClass: "bg-white" }, [
                    _c(
                      "div",
                      { staticClass: "cropper-cont" },
                      [
                        _c("vue-cropper", {
                          ref: "cropper",
                          attrs: {
                            img: _vm.option.img,
                            outputSize: _vm.option.size,
                            outputType: _vm.option.outputType,
                            info: true,
                            full: _vm.option.full,
                            canMove: _vm.option.canMove,
                            canMoveBox: _vm.option.canMoveBox,
                            fixedBox: _vm.option.fixedBox,
                            original: _vm.option.original,
                            autoCrop: _vm.option.autoCrop,
                            autoCropWidth: _vm.option.autoCropWidth,
                            autoCropHeight: _vm.option.autoCropHeight,
                            centerBox: _vm.option.centerBox,
                            high: _vm.option.high,
                            infoTrue: _vm.option.infoTrue,
                            enlarge: _vm.option.enlarge,
                          },
                          on: {
                            realTime: _vm.realTime,
                            imgLoad: _vm.imgLoad,
                            cropMoving: _vm.cropMoving,
                          },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "pre mt8" }, [
                      _c("section", { staticClass: "pre-item" }, [
                        _c("div", { style: _vm.previewStyle2 }, [
                          _c("div", { style: _vm.previews.div }, [
                            _c("img", {
                              style: _vm.previews.img,
                              attrs: { src: _vm.previews.url },
                            }),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "test-button mt8" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.finish("blob")
                            },
                          },
                        },
                        [_c("label", { staticClass: "btn" }, [_vm._v("保存")])]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }